export default __webpack_public_path__ + "static/media/logo_pconsultoria.172a1e70.jpeg";